import { useEffect, useState } from "react";
import axios from "axios";
import { Quote } from "lucide-react";
import { Container } from "./blocks";
import { Reveal } from "./motion";

const Empty = () => (
  <div className="placeholder-box rounded-3xl p-10 text-center sm:p-16">
    <Quote size={32} aria-hidden="true" className="mx-auto text-[#F3C649]" />
    <p className="label mt-6">Reserved space</p>
    <h2 className="mt-4 font-display text-4xl font-semibold">Approved testimonials will appear here.</h2>
    <p className="mx-auto mt-4 max-w-lg text-[#C8C5BB]">Only testimonials approved by participants and partners will be added.</p>
  </div>
);

const List = ({ items }) => (
  <>
    <p className="label">In their words</p>
    <h2 className="mt-4 font-display text-4xl font-semibold sm:text-5xl">What partners and participants say.</h2>
    <ul className="mt-12 grid gap-5 md:grid-cols-2">
      {items.map((t, i) => (
        <Reveal key={t.id} delay={(i % 2) * 0.08}>
          <li className="flex h-full flex-col justify-between rounded-3xl border border-[#D4AF37]/25 bg-[#12141C] p-8 sm:p-10" data-testid={`public-testimonial-${i}`}>
            <figure>
              <Quote size={28} aria-hidden="true" className="text-[#F3C649]" />
              <blockquote className="mt-6 font-display text-2xl leading-snug text-[#F9F8F6] sm:text-3xl">“{t.quote}”</blockquote>
              <figcaption className="mt-8 text-sm text-[#C8C5BB]">
                <span className="font-semibold text-[#F9F8F6]">{t.name}</span>{t.role ? ` — ${t.role}` : ""}
              </figcaption>
            </figure>
          </li>
        </Reveal>
      ))}
    </ul>
  </>
);

export const Testimonials = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) return undefined;
    axios.get(`${base}/api/testimonials`)
      .then((r) => { if (alive) setItems(Array.isArray(r.data) ? r.data : []); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <section className="py-24" data-testid="testimonials-section">
      <Container><Reveal>{items.length ? <List items={items} /> : <div data-testid="testimonials-placeholder"><Empty /></div>}</Reveal></Container>
    </section>
  );
};
